import { createRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Action, Subject } from '@erp/authz';
import { Spinner } from '@/components/ui/spinner';
import ErrorMessage from '@/components/errorMessage/ErrorMessage';
import { usePageReady } from '@/hooks/usePageReady';
import { orpc } from '@/api/rpc/client';
import { WorkbookWorkspace } from './WorkbookWorkspace';
import { WORKBOOK_FRESH_MS } from './workbookQueryTimes';
import { Route as parent, requirePermission } from '../route';
function WorkbookPage() {
  const { workbookId } = Route.useParams();
  const workbook = useQuery(
    orpc.workbooks.get.queryOptions({
      input: { workbookId },
      // The editor holds the Definition from here on and writes each save back
      // into this query: a read of the whole Workbook (hundreds of KB) is fresh
      // for a while, so the parts of the page that mount after it (and a
      // window refocus) don't fetch it again. Coming back to it later does.
      staleTime: WORKBOOK_FRESH_MS,
    }),
  );
  usePageReady({
    ready: !workbook.isPending,
    outcome: workbook.error ? 'error' : 'success',
  });
  if (workbook.isPending) return <Spinner />;
  if (workbook.error) return <ErrorMessage error={workbook.error} />;
  return workbook.data ? (
    <WorkbookWorkspace key={workbookId} initial={workbook.data} />
  ) : null;
}
export const Route = createRoute({
  getParentRoute: () => parent,
  path: '/workbooks/$workbookId',
  component: WorkbookPage,
  beforeLoad: async ({ context }) =>
    requirePermission({
      context,
      action: Action.Read,
      subject: Subject.Workbook,
    }),
});
